import type { TUserOrganization } from '@src/models/interfaces/user.interface';
import type { JurisdictionIdentifier } from '@src/packages/utils/nationalId';
import UserService from '@src/services/UserService';

const userService = new UserService();

/**
 * Persists an org-scoped attendance overlay before journey / replacement flows
 * that rely on backend jurisdiction gates.
 *
 * Uses a targeted Firestore patch via `UserService.updateJurisdictionId` (not
 * full `user.update`) so membership fields like `divisions` / `access` are never
 * rewritten from a partial client payload — required for org users with empty
 * `divisions` who otherwise hit permission / validation failures on save.
 */
export const persistOrganizationUserJurisdictionId = async (
  organizationId: string,
  orgUser: TUserOrganization,
  jurisdictionId: JurisdictionIdentifier,
): Promise<void> => {
  if (!orgUser.id) {
    throw new Error('Organization user id is required');
  }

  await userService.updateJurisdictionId(organizationId, orgUser.id, jurisdictionId);
};
